import RestResource from '../rest.service';
import Service from '../api.service';

export default class DollarQuotationService extends RestResource {
  map(payload) {
    return {
      date: payload.date,
      divisa: payload.divisa,
      billete: payload.billete,
      manual: payload.manual,
    };
  }

  getAvailableDates() {
    return Service.get(`${this.getResource()}/available-dates`).catch(this.handleErrors);
  }

  constructor() {
    super('dollar-quotations');
  }
}
